import React from 'react';
import { FaFacebook } from 'react-icons/fa';

const FacebookCommunityCard: React.FC = () => {
  return (
    <div className="max-w-xl mx-auto my-6 p-6 bg-white rounded-2xl shadow-md border border-gray-200">
      <div className="flex items-center gap-4">
        <FaFacebook className="text-blue-600 text-4xl" />
        <div>
          <h2 className="text-xl font-bold text-gray-800">Join the FivePrayer Community</h2>
          <p className="text-gray-600 text-sm">
            Welcome to the Official FivePrayer Support Group! 🤲✨
          </p>
        </div>
      </div>
      <div className="mt-4 text-gray-700 text-sm leading-relaxed">
        📌 <strong>Group Purpose:</strong><br />
        This is the dedicated community for users of the FivePrayer plugin — your all-in-one Islamic tool.
        Get support, share feedback, and connect with other users.
      </div>
      <div className="mt-6 text-center">
        <a
          href="https://www.facebook.com/groups/fiveprayer"
          target="_blank"
          rel="noopener noreferrer"
          className="inline-block px-5 py-2 bg-blue-600 text-white rounded-full font-medium hover:bg-blue-700 transition"
        >
          Join the Facebook Group
        </a>
      </div>
    </div>
  );
};

export default FacebookCommunityCard;